import { render, staticRenderFns } from "./crowdSet.vue?vue&type=template&id=2e9a5a4d&"
import script from "./crowdSet.vue?vue&type=script&lang=js&"
export * from "./crowdSet.vue?vue&type=script&lang=js&"
import style0 from "./crowdSet.vue?vue&type=style&index=0&id=2e9a5a4d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports